import React from "react";

/**
 * Top bar for event/class detail pages — back control + optional actions.
 */
export default function DetailPageNav({ back, actions = null, className = "" }) {
  return (
    <div className={`max-w-page mx-auto px-4 pt-5 pb-2 flex items-center justify-between gap-2 ${className}`}>
      {back}
      {actions ? <div className="flex items-center gap-2">{actions}</div> : <span />}
    </div>
  );
}
